<template>
  <v-list-item>
    <v-list-tile router :href="{ name: 'MessengerMessage', params: { id: this.conversation._id } }">
      <v-list-tile-content>
        <v-list-tile-title>
          <v-icon v-if="isUnread" class="blue--text">brightness_1</v-icon>
          {{ user.name }}
        </v-list-tile-title>
      </v-list-tile-content>
      <v-list-tile-action>
        <v-list-tile-action-text>
          <date-formatter :value="conversation.lastMessageAt"></date-formatter>
        </v-list-tile-action-text>
      </v-list-tile-action>
    </v-list-tile>
  </v-list-item>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { Date as DateFormatter } from '@/components/formatters'
  import withConversation from '@/mixins/withConversation'
  export default {
    components: {
      DateFormatter
    },
    mixins: [withConversation],
    computed: {
      ...mapGetters({
        pending: 'skiliko/conversations/pending'
      }),
      isUnread () {
        return !!this.pending[this.conversation._id]
      }
    }
  }
</script>

<style lang="stylus" scoped>
  @import "../../variables"

  .router-link-exact-active {
    background: $grey.lighten-2;

    &::before {
      content: '';
      display: block;
      position: absolute;
      width: 0;
      height: 0;
      border: solid 8px transparent;
      border-right-color: #fff;
      right: 0;
    }
  }

  .list__item {
    border-bottom: solid 1px rgba(0, 0, 0, $material-theme.divider-percent);
  }

  i {
    font-size: .75em;
    margin-right: .25em;
  }
</style>



// WEBPACK FOOTER //
// src/components/messenger/ConversationItem.vue